import { useAuth } from '@/contexts/AuthContext';
import { useSubscription } from './useSubscription';

/**
 * Unified hook to determine if auth and subscription state is ready
 * Returns true only when ALL auth-related checks are complete:
 * - Auth loading complete
 * - Profile loaded (for authenticated users)
 * - Role loaded (for authenticated users)
 * - Subscription loading complete
 */
export function useAuthReady() {
  const { isLoading: authLoading, user, profile, role } = useAuth();
  const { isLoading: subLoading } = useSubscription();
  
  // If not loading and user exists, ensure profile and role are also loaded
  const profileReady = !user || (!!profile && !!role);
  
  return {
    isReady: !authLoading && !subLoading && profileReady
  };
}
